import AxiosInstance from "../services/networkServices";

// auth apis
export const login = (data) => AxiosInstance.post(`/auth/admin-login`, data);
export const logout = (data) => AxiosInstance.post(`/auth/logout`, data);
export const forgotPassword = (data) =>
  AxiosInstance.post(`/auth/forgot-password`, data);
export const changePassword = (data) =>
  AxiosInstance.post(`/auth/change-password`, data);



export const getUserDetail = (id) =>
  AxiosInstance.get(`/admin/view-user/${id}`);

export const getUserVotes = async (userId, page = 1, limit = 20) => {
  const response = await AxiosInstance.get(
    `/admin/view-user/${userId}/votes?page=${page}&limit=${limit}`
  );
  return response.data;
};
// Admin-panel account creation lives in ./adminAccounts.js
export const updateStatus = (id) =>
  AxiosInstance.patch(`/admin/block-unblock-user/${id}`);

export const activateTicket = async (ticketId) => {
  const res = await AxiosInstance.patch(`/admin/block-user/${ticketId}`);
  return res?.data
}

export const blockUser = async (userId) => {
  const res = await AxiosInstance.patch(`/admin/block-user/${userId}`);
  return res?.data
}




// settings apis
export const updateProfile = (payload) => AxiosInstance.post(`/user`, payload);
export const getProfile = (data) => AxiosInstance.get(`/user/`);


// manage app data apis
export const setupHome = (data) => AxiosInstance.post(`/admin/setup-app`, data);
export const getHomeData = () => AxiosInstance.get(`/admin/get-app-settings`);
export const updateTermAndConditions = (data) =>
  AxiosInstance.patch(`/admin/update-term-and-conditions`, data);
export const getFAQ = () => AxiosInstance.get(`/admin/faq`);
export const updateFAQ = (data) => AxiosInstance.put(`/admin/faq`, data);


// FAQ management APIs
export const createFAQ = (data) => AxiosInstance.post('/faq', data);
export const listFAQs = async ({ page, limit }) => {
  try {
    const response = await AxiosInstance.post('/faq/list', { page, limit });
    return response.data;
  } catch (error) {
    throw error.response.data;
  }
};

export const editFAQ = (id, data) => AxiosInstance.put(`/faq/${id}`, data);
export const deleteFAQ = (id) => AxiosInstance.delete(`/faq/${id}`);


// category
export const createCategory = (data) => AxiosInstance.post(`/category/`, data);
export const listCategories = async ({ type, page, limit }) => {
  try {
    const response = await AxiosInstance.post('/category/list', { type, page, limit });
    return response.data;
  } catch (error) {
    throw error.response.data;
  }
};
export const viewCategory = (id) => AxiosInstance.get(`/category/${id}`);
export const editCategory = (id, data) => AxiosInstance.put(`/category/${id}`, data);
export const deleteCategory = (id, data) => AxiosInstance.delete(`/category/${id}`, { data });